import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import zh from './zh'
import zhTW from './zh-TW'
import jaJP from './ja-JP'
import koKR from './ko-KR'
import esES from './es-ES'
import frFR from './fr-FR'
import deDE from './de-DE'
import itIT from './it-IT'
import noNO from './no-NO'

Vue.use(VueI18n)

const messages = {
  'en-US': en,
  'zh-CN': zh,
  'zh-TW': zhTW,
  'ja-JP': jaJP,
  'ko-KR': koKR,
  'es-ES': esES,
  'fr-FR': frFR,
  'de-DE': deDE,
  'it-IT': itIT,
  'no-NO': noNO
}

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'en-US',
  messages
})

export default i18n
